// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth,setPersistence,browserLocalPersistence } from "firebase/auth";

// ✅ Use your actual Firebase config from Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyB053LkC_i7zIZn6J2f9sasHdv7kVVexEI",
    authDomain: "upskill-semion.firebaseapp.com",
    projectId: "upskill-semion",
    storageBucket: "upskill-semion.firebasestorage.app",
    messagingSenderId: "315425570609",
    appId: "1:315425570609:web:9cfaea9731a0de495afa10",
    measurementId: "G-ETYHZDZFY1"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const authentication = getAuth(app);

setPersistence(authentication, browserLocalPersistence)
  .then(() => console.log("Firebase persistence set to Local Storage"))
  .catch((error) => console.error("Error setting persistence:", error));

//console.log("Firebase app initialized");
export const auth=authentication;
